// extracted by mini-css-extract-plugin
export var label = "_ew-2";
export var slideContainer = "_ew-0";
export var slider = "_ew-1";